import { ROOT_FOLDER, RECENT_FOLDER } from '@/project/documents/constants/special-folders'

export const getters = {
  isRootFolder: state => state.paginatedDocumentsCurrentFolderId === ROOT_FOLDER.id,
  isRecentFolder: state => state.paginatedDocumentsCurrentFolderId === RECENT_FOLDER.id,
  isTodoFolder: state => state.paginatedDocumentsCurrentFolderId === state.foldersTree?.todoFolderId,
  isQaFolder: state => state.paginatedDocumentsCurrentFolderId === state.foldersTree?.qaFolderId,
  isSpecialFolderContext: (state, getters, rootState, rootGetters) => {
    return getters.isRecentFolder ||
      getters.isTodoFolder ||
      getters.isQaFolder ||
      rootGetters['documentsBreadcrumb/hasTodoFolderOrChild'] ||
      rootGetters['documentsBreadcrumb/hasQaFolderOrChild']
  },
}
